import { NavLink } from "./NavLink"
import { HiHome, HiSearch } from "react-icons/hi"
import { IoIosAppstore } from "react-icons/io"
import { RiSettings4Fill } from "react-icons/ri"
import useT from "../utils/useT"
import AppollowLogo from "./AppollowLogo"
import useGlobalStore from "../stores/global"
import { BiNews } from "react-icons/bi"
import { AdUnit } from "next-google-adsense"

const SideNavbar = () => {
  const t = useT()
  const isDark = useGlobalStore((state) => state.isDark)

  return (
    <div className="side-navbar position-fixed">
      <div className=" card rounded-m p-3">
        <div className="m-auto">
          <AppollowLogo fill={isDark ? "#fff" : "#4a89dc"} width="200px" />
        </div>
        <hr />
        <NavLink
          className="side-nav-item apps-tab d-flex align-items-center my-2 mt-2"
          href="/?page=apps"
          as="/apps"
          title="apps"
          exact
        >
          <IoIosAppstore className="side-nav-icon" />
          <div className="side-nav-text">{t.navBar.apps}</div>
        </NavLink>
        <NavLink
          className="side-nav-item search-tab d-flex align-items-center my-2"
          href="/?page=search"
          as="/search"
          title="search"
          exact
        >
          <HiSearch className="side-nav-icon" />
          <div className="side-nav-text">{t.navBar.search}</div>
        </NavLink>
        <NavLink
          className="side-nav-item home-tab d-flex align-items-center my-2"
          href="/?page=home"
          as="/"
          title="home"
          exact
        >
          <HiHome className="side-nav-icon" />
          <div className="side-nav-text">{t.navBar.home}</div>
        </NavLink>
        <NavLink
          className="side-nav-item submit-tab d-flex align-items-center my-2"
          href="/?page=feed"
          as="/feed"
          title="feed"
          exact
        >
          <BiNews className="side-nav-icon" />
          <div className="side-nav-text">{t.navBar.feed}</div>
        </NavLink>
        <NavLink
          className="side-nav-item settings-tab d-flex align-items-center my-2"
          href="/?page=settings"
          as="/settings"
          title="settings"
          exact
        >
          <RiSettings4Fill className="side-nav-icon" />
          <div className="side-nav-text">{t.navBar.settings}</div>
        </NavLink>
        <div className="side-nav-glider" />
      </div>

      <div style={{
        width: "100%",
        height: "calc(100vh - 495px)",
      }}>
        <AdUnit
          publisherId="pub-8210764995783356"
          slotId="5462058164"
          layout="display"
        />
      </div>
    </div>
  )
}

export default SideNavbar
